"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const reducers_1 = require("../../../reducers");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const PopoverTextRadioButtonComponent_1 = require("../../utils/PopoverTextRadioButtonComponent");
const TapBehaviorBody_1 = require("./TapBehaviorBody");
const Row_1 = require("../components/Row");
const MobilePopover_1 = require("../components/MobilePopover");
const FormSection_1 = require("../../utils/FormSection");
const actions_1 = require("../../../actions");
class TapBehaviorContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTapNotificationOptions: false,
        };
        this.getClickableView = this.getClickableView.bind(this);
        this.getTapBehaviorType = this.getTapBehaviorType.bind(this);
        this.handleShowNotificationOptions = this.handleShowNotificationOptions.bind(this);
        this.handleSelectTapOption = this.handleSelectTapOption.bind(this);
        this.tapNotificationRow = this.tapNotificationRow.bind(this);
        this.getTapNotificationRowClickable = this.getTapNotificationRowClickable.bind(this);
    }
    getTapBehaviorType() {
        const { isTapBehaviorDeepLink, tapBehaviorType } = this.props;
        if (isTapBehaviorDeepLink) {
            return 'OPEN_URL';
        }
        if (tapBehaviorType === 'OPEN_URL') {
            return 'PRESENT_WEBSITE';
        }
        return tapBehaviorType;
    }
    handleShowNotificationOptions() {
        this.setState({
            showTapNotificationOptions: !this.state.showTapNotificationOptions,
        });
    }
    handleSelectTapOption(type) {
        const { closeTapBehaviorSelector, device, updateNotificationDeliverable } = this.props;
        updateNotificationDeliverable({
            tapBehavior: {
                type,
                url: null,
                experienceID: null,
            },
        });
        if (device === 'Mobile') {
            closeTapBehaviorSelector();
        }
        else {
            this.setState({
                showTapNotificationOptions: false,
            });
        }
    }
    getClickableView() {
        const { device, tapBehaviorType } = this.props;
        const { showTapNotificationOptions } = this.state;
        const popoverProps = {
            placement: 'left',
        };
        const getClickable = () => {
            switch (device) {
                case 'Desktop':
                    return (React.createElement(src_1.Button, { text: "Change", type: "regular", mouseDownColors: {
                            active: src_1.turquoise,
                            inactive: src_1.aquamarine,
                        }, key: "tapBehavior1" }));
                case 'Tablet':
                    return React.createElement(src_1.ChangeIcon, { fill: src_1.titanium, key: "tapBehavior1" });
                case 'Mobile':
                default:
                    return null;
            }
        };
        return (React.createElement(src_1.PopoverContainer, { id: "tapBehaviorNotificationPopover", popoverProps: popoverProps, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', onClick: this.handleShowNotificationOptions, showPopover: showTapNotificationOptions }, [
            getClickable(),
            React.createElement("div", { style: {
                    width: 384,
                }, key: "tapBehavior2" },
                React.createElement(PopoverTextRadioButtonComponent_1.default, { onClick: this.handleSelectTapOption, selectedTapOption: this.getTapBehaviorType(), device: device, options: {
                        PRESENT_EXPERIENCE: 'Present an experience',
                        PRESENT_WEBSITE: 'Present a website',
                        OPEN_URL: 'Open a deep link',
                        DEFAULT: 'Open the app',
                    } })),
        ]));
    }
    getTapBehaviorCopy(behavior) {
        switch (behavior) {
            case 'PRESENT_EXPERIENCE':
                return 'Present an experience';
            case 'PRESENT_WEBSITE':
                return 'Present a website';
            case 'OPEN_URL':
                return 'Open a deep link';
            case 'DEFAULT':
            default:
                return 'Open the app';
        }
    }
    tapNotificationRow() {
        const { device, isTapBehaviorSelectorOpen, tapBehaviorType } = this.props;
        const row = (React.createElement(React.Fragment, null,
            React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                React.createElement(src_1.Text, { text: "What happens when the notification is tapped?", size: "small", label: true }),
                React.createElement(src_1.Text, { text: this.getTapBehaviorCopy(this.getTapBehaviorType()), size: "large" })),
            this.getClickableView()));
        switch (device) {
            case 'Mobile':
                const child = (React.createElement(PopoverTextRadioButtonComponent_1.default, { key: "tapBehavior2", options: {
                        PRESENT_EXPERIENCE: 'Present an experience',
                        PRESENT_WEBSITE: 'Present a website',
                        OPEN_URL: 'Open a deep link',
                        DEFAULT: 'Open the app',
                    }, onClick: this.handleSelectTapOption, selectedTapOption: this.getTapBehaviorType(), device: device }));
                return (React.createElement(React.Fragment, null,
                    row,
                    isTapBehaviorSelectorOpen !== 'close' &&
                        ReactDOM.createPortal(React.createElement(MobilePopover_1.default, { title: "What happens when the notification is tapped?", children: child, onClose: () => this.props.closeTapBehaviorSelector(), animation: isTapBehaviorSelectorOpen }), document.getElementById('mainModalLeft'))));
            case 'Desktop':
            case 'Tablet':
            default:
                return row;
        }
    }
    getTapNotificationRowClickable() {
        const { device, openTapBehaviorSelector } = this.props;
        switch (device) {
            case 'Mobile':
                return openTapBehaviorSelector();
            case 'Tablet':
            case 'Desktop':
            default:
                return this.handleShowNotificationOptions();
        }
    }
    render() {
        const { device } = this.props;
        return (React.createElement(FormSection_1.default, { device: device },
            React.createElement(src_1.Text, { text: "Tap Behavior", size: "h1", textStyle: { margin: '24px 0' } }),
            React.createElement(Row_1.default, { onClick: this.getTapNotificationRowClickable }, this.tapNotificationRow()),
            React.createElement(TapBehaviorBody_1.default, { device: device, selectedTapOption: this.getTapBehaviorType() })));
    }
}
const mapStateToProps = (state) => {
    const { tapBehavior: { type }, } = reducers_1.getEditableCampaignDeliverable(state);
    return {
        tapBehaviorType: type,
        isTapBehaviorSelectorOpen: reducers_1.getIsTapBehaviorSelectorOpen(state),
        isTapBehaviorDeepLink: reducers_1.getIsTapBehaviorDeepLink(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateNotificationDeliverable: (d) => {
            dispatch(actions_1.updateNotificationDeliverable(d));
        },
        openTapBehaviorSelector: () => {
            dispatch(actions_1.openTapBehaviorSelector());
        },
        closeTapBehaviorSelector: () => {
            dispatch(actions_1.closeTapBehaviorSelector());
        },
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(TapBehaviorContainer);
